import script from "./LayoutDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutDefault.vue?vue&type=script&setup=true&lang=js"

import "./LayoutDefault.vue?vue&type=style&index=0&id=5637d489&lang=scss"

const __exports__ = script;

export default __exports__